//用户信息

<template>
	<div class="">
			<div class="moxingtu">
				<div class="locNav">
					<ul>
						<li  v-for="(marker,mindex) in plateList" :key="mindex" :class="{active:mindex == activeMindex}">
							<a  @click="changeMap(mindex)">{{marker.name}}</a>
						</li>
						
					</ul>
				</div>
				<div class="mapbox"  v-for="(marker,mindex) in plateList" :key="mindex" v-if="mindex == activeMindex">
					<img :src="formatImgSrc(marker.image)" />
					<!--图例-->
					<div class="dlhj-legend" v-if="marker.plate.markers">
						<div v-if="marker.plate.markers.cabinet && marker.plate.markers.cabinet.length">
							<div class="libox"><i class="fa fa-circle"></i></div>
							机柜
						</div>
						<div v-if="marker.plate.markers.humiture && marker.plate.markers.humiture.length">
							<div class="libox"><i class="fa fa-thermometer"></i></div>
							温湿度
						</div>
						<div v-if="marker.plate.markers.smoke && marker.plate.markers.smoke.length">
							<div class="libox"><i class="fa fa-fire"></i></div>
							烟雾
						</div>
						<div v-if="marker.plate.markers.leakage && marker.plate.markers.leakage.length">
							<div class="libox"><i class="fa fa-tint"></i></div>
							漏水
						</div>
						<div v-if="marker.plate.markers.aircondition && marker.plate.markers.aircondition.length">
							<div class="libox"><i class="fa fa-snowflake-o"></i></div>
							空调
						</div>
						<div v-if="marker.plate.markers.ups && marker.plate.markers.ups.length>0">
							<div class="libox"><i class="fa fa-battery-full"></i></div>
							UPS
						</div>
						<div v-if="marker.plate.markers.distribution && marker.plate.markers.distribution.length">
							<div class="libox"><i class="fa fa-bolt"></i></div>
							配电柜
						</div>
						<div v-if="marker.plate.markers.fire && marker.plate.markers.fire.length">
							<div class="libox"><i class="fa fa-fire-extinguisher"></i></div>
							消防
						</div>
						<div v-if="marker.plate.markers.door && marker.plate.markers.door.length">
							<div class="libox"><i class="fa fa-columns"></i></div>
							门禁
						</div>
						<div v-if="marker.plate.markers.lamp && marker.plate.markers.lamp.length">
							<div class="libox"><i class="fa fa-lightbulb-o"></i></div>
							照明
						</div>
						
					</div>

					<div v-if="marker.plate.markers" v-for="(typeItem,tkey,tindex) in marker.plate.markers" :key="tindex">
						<div v-for="(devItem,dindex) in typeItem" v-if="typeItem.length && typeItem.length>0"
							:key="dindex"
							:style="{left:(devItem.locationX+offWidth)*100+'%',top:(devItem.locationY+offHeight)*100+'%'}"
							class="msgbox">
              
							<h2 :class="{danger:devItem.isHealthy=='N'}">
			                  	<i @click="changeActiveTool(devItem)" 
			                  		:class="{'fa fa-snowflake-o':tkey=='aircondition','fa fa-circle':tkey=='cabinet','fa fa-thermometer':tkey=='humiture',
			                  		'fa fa-fire':tkey=='smoke','fa fa-tint':tkey=='leakage','fa fa-battery-full':tkey=='ups','fa fa-bolt':tkey=='distribution',
			                  		'fa fa-fire-extinguisher':tkey=='fire','fa fa-columns':tkey=='door','fa fa-lightbulb-o':tkey=='lamp'}">
			                  	</i>
			                  </h2>
							<div class="tooltip" v-if="devItem.dataList" :class="{disnone:activeItemName!=devItem.name}">
								<h3><a :href="devItem.link">{{devItem.name}}</a></h3>
								<!--情况一-->
								<p v-if="threItem.name" v-for="(threItem,threkey,threindex) in devItem.dataList" :class="{danger:threItem.isHealthy=='N'}" :key="threindex">
									<i class="fa fa-tag"></i> {{threItem.name}}：
									<span>{{threItem.value}}{{threItem.unit}}</span>
								</p>
								<!--情况二 分AB相-->
								<div v-if="!threItem.name" v-for="(threItem,threkey,threindex) in devItem.dataList" :key="threindex">
									<p v-if="abcItem.name" v-for="(abcItem,abckey,abcindex) in threItem" :class="{danger:abcItem.isHealthy=='N'}" :key="abckey">
										<i class="fa fa-tag"></i> {{abcItem.name}}：
										<span>{{abcItem.value}}{{abcItem.unit}}</span>
									</p>
								</div>
								<!--情况三 分AB路且 分AB相-->
								<div v-if="!threItem.name" v-for="(threItem,threkey) in devItem.dataList" :key="threkey">
									<div v-if="!abItem.name" v-for="(abItem,abkey,abindex) in threItem" :key="abindex">
										<p v-if="abcItem.name" v-for="(abcItem,abckey) in abItem" :class="{danger:abcItem.isHealthy=='N'}" :key="abckey">
											<i class="fa fa-tag"></i> {{abcItem.name}}：
											<span>{{abcItem.value}}{{abcItem.unit}}</span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

	</div>
</template>
<script>
	export default {
		mounted() {
			this.$nextTick(function() {
				this.getLoad();
				
			})
			const timer = setInterval(() => {
				this.getLoad();
			}, 30000);

			this.$once('hook:beforeDestroy', () => {
				clearInterval(timer);
			})
		},
		props: ['selectComId'],
		data() {
			return {
				ifHasInfo: true,
				isLogouting: false,
				activeItemName: "",
				plateList: {},
				imgSrc: "",
				activeMindex:0,
				offHeight:-0.04,
				offWidth:0.0,
				myselectComId: this.selectComId
			}
		},
		methods: {
			/*提示框*/
			changeActiveTool(sitem) {
				if(this.activeItemName == sitem.name) {
					this.activeItemName = "";
				} else {
					this.activeItemName = sitem.name;
				}
			},
			//获取工作台系统数据开始 
			getLoad() {
				this.plateList = []
				this.myselectComId = this.selectComId;
				let valiCodeParams = {
					uid: this.getCookie('uid'),
					company_id: this.selectComId || 999,
					token: this.getCookie('token'),
					time: Date.parse(new Date()),
					terminalId: 4
				};
				this.sign2(valiCodeParams);
				this.$ajax.post(this.$store.state.domain2 + "/admin/DeviceView/DeviceViewList", this.$qs.stringify(valiCodeParams), {
					emulateJSON: true
				}).then(res => {
					if(res.data.code == 200 & res.data.data != null) {
						let markers = res.data.data.markers || {};
						this.plateList = res.data.data.plateList || [];
			

					} else if(res.data.code == 10008) {
						this.isLogouting = true;
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
					} else {
						//console.log(res.data.msg);
					}
				});

			},
			changeMap(mindex){
				this.activeMindex = mindex;
			},
			formatImgSrc(imgSrc) {
				if(imgSrc!=""){
					return this.$store.state.domain3 + imgSrc;
				}
				
			}

		}
	}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/components/model.vue